import { isAdminMemberProfileResponse, isMemberProfileCatalogsResponse, } from '@urbanik/api-contracts';
export class AdminMemberProfileApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
    }
}
async function call(url, init) {
    let r;
    try {
        r = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
            },
        });
    }
    catch {
        throw new AdminMemberProfileApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const p = await r.json().catch(() => null);
    const msg = p && typeof p.message === 'string' ? p.message : 'No pudimos completar la solicitud.';
    if (r.status === 400)
        throw new AdminMemberProfileApiError('validation', msg);
    if (r.status === 401)
        throw new AdminMemberProfileApiError('unauthorized', msg);
    if (r.status === 403)
        throw new AdminMemberProfileApiError('forbidden', msg);
    if (r.status === 404)
        throw new AdminMemberProfileApiError('not-found', msg);
    if (r.status === 409)
        throw new AdminMemberProfileApiError('conflict', msg);
    if (!r.ok)
        throw new AdminMemberProfileApiError('unavailable', msg);
    return p;
}
export async function getAdminMemberProfile(base, id, signal) {
    const p = await call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/profile`, { signal: signal ?? null });
    if (!isAdminMemberProfileResponse(p))
        throw new AdminMemberProfileApiError('invalid', 'El contrato del perfil es inválido.');
    return p;
}
export async function getMemberProfileCatalogs(base, signal) {
    const p = await call(`${base.replace(/\/$/, '')}/identity/member-profile/catalogs`, {
        signal: signal ?? null,
    });
    if (!isMemberProfileCatalogsResponse(p))
        throw new AdminMemberProfileApiError('invalid', 'El contrato de catálogos es inválido.');
    return p;
}
export async function updateAdminMemberProfile(base, id, input) {
    const p = await call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/profile`, { method: 'PATCH', body: JSON.stringify(input) });
    if (!isAdminMemberProfileResponse(p))
        throw new AdminMemberProfileApiError('invalid', 'El contrato del perfil es inválido.');
    return p;
}
